import { render, staticRenderFns } from "./fan.vue?vue&type=template&id=4c35ba13&scoped=true&"
import script from "./fan.vue?vue&type=script&lang=js&"
export * from "./fan.vue?vue&type=script&lang=js&"
import style0 from "./fan.vue?vue&type=style&index=0&id=4c35ba13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c35ba13",
  null
  
)

export default component.exports